import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', cb);
      // Some environments (device emulation, rotation) resize without a `change` event.
      window.addEventListener('resize', cb);
      return () => {
        mql.removeEventListener('change', cb);
        window.removeEventListener('resize', cb);
      };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** D02: Mobile Quick Edit below 768 CSS px. */
export const MOBILE_QUERY = '(max-width: 767.98px)';

/**
 * A phone in either orientation (M-01/M01): narrow, or a touch screen whose height is phone-sized
 * — a landscape phone is 840+ px wide but only ~400 px tall and must not get the desktop editor
 * or the two-window presenter view.
 */
export const PHONE_QUERY = '(max-width: 767.98px), (pointer: coarse) and (max-height: 540px)';

/** A horizontal swipe from pointer down/up positions: 'next' (leftward), 'prev' (rightward) or null. */
export function swipeDirection(start: { x: number; y: number; t: number }, end: { x: number; y: number; t: number }): 'next' | 'prev' | null {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2 || end.t - start.t > 800) return null;
  return dx < 0 ? 'next' : 'prev';
}
